import styled from 'styled-components';
import { NavLink as RouterNavLink } from 'react-router-dom';

export const NavLink = styled(RouterNavLink)`
  cursor: pointer;
  margin-left: 3.5rem;
  font-weight: 600;
  position: relative;

  &:visited {
    color: ${(props) => props.theme.white};
  }

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: ${(props) => props.theme.white};
    width: 100%;
    height: 1.25px;
    transition: transform 0.15s linear;
    transform: scaleY(0);
    margin-bottom: -2px;
  }

  &:hover,
  &.active {
    &:after {
      transform: scaleY(1);
    }
  }
`;
